import React from 'react';
import { Dashboard } from '../../pages';

const DashboardContainer = () => {


  return (
    <Dashboard
    />
  )
}

export default DashboardContainer